import { Text } from '@hhgtech/hhg-components'
import { Heading } from 'components/atoms/text'
import { domainLocales } from 'domainLocales'
import innertext from 'innertext'
import { Article } from 'interfaces/types'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { TRACK_GA } from 'utils/tracking'

import {
  ArticleType as ArticleConstType,
  ArticleType,
  DEFAULT_IMG,
  FEATURE_FLAG,
} from '../../../interfaces/constants'
import { ArticleCardWrapper } from '../../molecules/articleCardWrapper/index'
import {
  StyledRelatedPosts,
  StyledPostWrapper,
  StyledPostsContainer,
  StyledLink,
} from './index.styled'

export type Props = {
  size?: 'lg' | 'sm'
  className?: string
  title?: string
  articleType?: ArticleType
  isMobile?: boolean
}

const PostsDivider = styled.div`
  width: 100%;
  height: 2px;
  background-color: #5ec08f;
  border-radius: 2px;
`

const RelatedPosts = ({
  className,
  title,
  // size = 'sm',
  articles = [],
  isMobile,
  articleType,
}: Props & {
  articles: Array<Article>
}) => {
  const { formatMessage: f } = useIntl()
  const router = useRouter()
  const { locale } = router
  const sL = locale || 'vi-VN' // standardized locale
  const selectedArticleType = articleType || FEATURE_FLAG.articleType

  if (articles?.length < 1) {
    return null
  }

  return (
    <StyledRelatedPosts
      data-show-full={selectedArticleType !== ArticleConstType.ArticleType3}
      className={className}
    >
      <>
        <Text
          size={isMobile ? 'xs' : 'md'}
          color="#8C8C8C"
          type="bold"
          style={{
            textTransform: 'uppercase',
            ...(!isMobile
              ? {
                  fontSize: 18,
                }
              : {}),
          }}
        >
          {title ||
            f({
              id:
                articles.length > 1
                  ? 'articlePage.relatedPostsSectionTitle.many'
                  : 'articlePage.relatedPostsSectionTitle.one',
            })}
        </Text>
        <PostsDivider />
        <StyledPostsContainer
          data-show-full={selectedArticleType !== ArticleConstType.ArticleType3}
        >
          {articles.map((article, index) =>
            selectedArticleType === ArticleConstType.ArticleType3 ? (
              <StyledLink
                key={index}
                href={article.permalink}
                data-event-category={
                  TRACK_GA.RELATE_ARTICLE_INTERNAL_LINK.category
                }
                data-event-action={`Click ${index + 1}`}
                data-event-label={`https://${domainLocales[sL]}${article.permalink}`}
                className="non-pointer-event-child"
              >
                {/* <StyledHeading */}
                <Heading
                  className="related-post"
                  // tag="h5"
                  type="h3"
                >
                  {article.postTitle}
                </Heading>
              </StyledLink>
            ) : (
              <StyledPostWrapper key={index}>
                <ArticleCardWrapper
                  article={article}
                  className={'related-article-card'}
                  type="author"
                  size={isMobile ? 'sm' : 'md'}
                  data-event-category="Related Article in Content"
                  data-event-action="Click"
                  data-event-label={`https://${domainLocales[sL]}${article.permalink}`}
                  banner={
                    <img
                      loading="lazy"
                      src={
                        (isMobile
                          ? article.featureImageMobileXs
                          : article.featureImageMobile) || DEFAULT_IMG
                      }
                      alt={article.postTitle}
                    />
                  }
                  categoryName={
                    article.category?.displayName ||
                    article.categories?.[0]?.displayName ||
                    ''
                  }
                  title={article.postTitle}
                  avatarImgRenderer={(avatar, name) => (
                    <img
                      loading="lazy"
                      src={avatar}
                      style={{ width: '32px', height: '32px' }}
                      alt={name}
                    />
                  )}
                  uploadTime={article.modifiedTime || ''}
                  text={
                    article.excerpt ||
                    innertext(
                      article.description ||
                        article.postContent?.split('\r\n')[0] ||
                        '',
                    )
                  }
                  styleLabel={{
                    color: article.category.textColor || '#008C50',
                  }}
                  articleLink={article.permalink}
                  categoryLink={
                    article.category?.permalink ||
                    article.categories?.[0]?.permalink ||
                    ''
                  }
                />
              </StyledPostWrapper>
            ),
          )}
        </StyledPostsContainer>
      </>
    </StyledRelatedPosts>
  )
}

export { RelatedPosts }
